<template>
  <div>
    <button
    v-if="showBackToTop"
    class="back-to-top"
    @click="backToTop"
  >
    <img src="https://download.hecoos.com/enlightv/2025-17/c97ffd76b131b2c2f724bec6da9b4ab3.png" alt="">
  </button>

    <div class="ai-link-box">
      <div class="ai-links" :class="{ 'is-open': aiOpen }">
        <ul class="ai-links-arc">
          <li class="ai-link-item" @click.stop="handleClickAiLink('Gemini')">
            <img src="https://download.hecoos.com/enlightv/2026-04/995f741d86841c60764310a058660aa7.png" alt="Gemini">
          </li>
          <li class="ai-link-item" @click.stop="handleClickAiLink('DeepSeek')">
            <img src="https://download.hecoos.com/enlightv/2026-04/215dd6bd3d73d96908ba5dda3197952e.png" alt="DeepSeek">
          </li>
          <li class="ai-link-item" @click.stop="handleClickAiLink('doubao')">
            <img src="https://download.hecoos.com/enlightv/2026-04/a01d2da7d1314272669928a623f80b35.png" alt="豆包">
          </li>
          <li class="ai-link-item" @click.stop="handleClickAiLink('ChatGPT')">
            <img src="https://download.hecoos.com/enlightv/2026-04/7e0dc396e361f896a42125b213d24db8.jpeg" alt="ChatGPT">
          </li>
        </ul>
        <div class="ask-ai" @click.stop="toggleAiMenu">Ask AI</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBackToTop: false,
      aiOpen: false,
      aiPrompt:"I'm focusing on virtual production and full-domain production workflows. Elaborate on how hecoos implements its \"Design-to-Reality\" philosophy by integrating offline lighting programming, 3D scene simulation, and xR/VP virtual shooting. Please introduce its Studio software, Server hardware series, and its critical application value in previsualization for large-scale events. ",
      currentPath : 'https://www.hecoos.com/web/#/en'
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick() {
      if (!this.aiOpen) return;
      this.aiOpen = false;
    },
    toggleAiMenu() {
      if (this.isLoading) return;
      this.aiOpen = !this.aiOpen;
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.showBackToTop = scrollTop > 300;
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleClickCopy(){
      const textarea = document.createElement('textarea');
      textarea.value = `${this.aiPrompt} ${this.currentPath}`;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      // 移除临时元素
      document.body.removeChild(textarea);
      this.$message.success('Copied. You can paste it directly after opening');
    },
    handleClickAiLink(type){
      if(this.isLoading) return;
      this.isLoading = true;
      this.aiOpen = false;
      this.handleClickCopy();
      setTimeout(() => {
        let url = '';
        switch(type){
          case 'Gemini':
            // url = `https://gemini.google.com/`;
            url = `https://www.google.com/search?udm=50&q=${this.aiPrompt} ${encodeURIComponent(this.currentPath)}`;
            break;
          case 'DeepSeek':
            url = `https://chat.deepseek.com/?q=${this.aiPrompt} ${encodeURIComponent(this.currentPath)}`;
            break;
          case 'doubao':
            url = `https://www.doubao.com/chat/?q=${this.aiPrompt} ${encodeURIComponent(this.currentPath)}`;
            break;
          case 'ChatGPT':
            url = `https://chatgpt.com/?q=${this.aiPrompt} ${encodeURIComponent(this.currentPath)}`;
            break;
        }
        this.isLoading = false;
        window.open(url, '_blank');
      }, 1500);

    },
  }
};
</script>

<style scoped lang="scss">
.back-to-top {
  position: fixed;
  bottom: 190px;
  right: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 9999;
}
.back-to-top img{
  width: 60px;
  height: 60px;
}


.ai-link-box {
  position: fixed;
  right: 40px;
  bottom: 125px;
  z-index: 9999;
}

.ai-links {
  position: relative;
  // 以按钮尺寸作为定位基准，保证半圆始终围绕按钮中心
  --btn-w: 82px;
  --btn-h: 32px;
  width: var(--btn-w);
  height: var(--btn-h);
  --open: 0;
}

.ai-links.is-open {
  --open: 1;
}

.ask-ai {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  line-height: 32px;
  background-color: #147cf5;
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.18);
}

// 形成半圆的图标分布（围绕在 Ask AI 按钮上方）
.ai-links-arc {
  --r: 88px;
  position: absolute;
  left: 50%;
  top: -5px;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  list-style: none;
  transform: translate(-50%, -50%);
}

.ai-link-item {
  position: absolute;
  left: 0;
  top: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  pointer-events: none;
  opacity: 0;
  transition:
    transform 260ms cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 180ms ease,
    background 0.2s ease;
  transform-origin: 0 0;

  // 默认角度（避免未命中 nth-child 时堆叠）
  --a: -90deg;
  transform:
    rotate(var(--a))
    translate(0, calc(-1 * var(--r) * var(--open)))
    rotate(calc(-1 * var(--a)))
    scale(calc(0.2 + 0.8 * var(--open)));

  opacity: var(--open);

  &:hover {
    background: #fff;
    transform:
      rotate(var(--a))
      translate(0, calc(-1 * var(--r) * var(--open)))
      rotate(calc(-1 * var(--a)))
      scale(calc((0.2 + 0.8 * var(--open)) * 1.06));
  }

  img {
    width: 26px;
    height: 26px;
    border-radius: 6px;
  }
}

// 展开时才可点
.ai-links.is-open .ai-link-item {
  pointer-events: auto;
}

// 4 个入口：从左上到右上形成半圆
.ai-links-arc > li:nth-child(1) { --a: -150deg; }
.ai-links-arc > li:nth-child(2) { --a: -110deg; }
.ai-links-arc > li:nth-child(3) { --a: -70deg; }
.ai-links-arc > li:nth-child(4) { --a: -30deg; }

// 错峰动画：从按钮“弹出”的感觉更明显
.ai-links-arc > li:nth-child(1) { transition-delay: 0ms; }
.ai-links-arc > li:nth-child(2) { transition-delay: 40ms; }
.ai-links-arc > li:nth-child(3) { transition-delay: 80ms; }
.ai-links-arc > li:nth-child(4) { transition-delay: 120ms; }
</style>
